<template>
  <div
    v-if="shouldShowBanner && globalVar.in_app_payments"
    class="ai-reason-bnr sp"
  >
    <button class="ai-reason-bnr-btn" @click="handleBannerClick">
      <span class="ai-reason-bnr-btn__icon">💡</span>
      <span class="ai-reason-bnr-btn__text">
        <strong class="ai-reason-bnr-btn__title">{{ title }}</strong>
        <span class="ai-reason-bnr-btn__desc">{{ description }}</span>
      </span>
    </button>
    <button @click="closeBtn" class="ai-reason-bnr-close-btn">×</button>
  </div>
</template>

<style lang="scss" scoped>
.ai-reason-bnr {
  button {
    background: none;
    cursor: pointer;
  }

  position: fixed;
  bottom: 10px;
  left: calc(50% - 160px);
  width: 320px;
  max-width: calc(100% - 20px);
  height: auto;
  z-index: 100;

  .ai-reason-bnr-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 0 0 15px -5px #777;
    text-align: left;

    &:hover {
      opacity: 1;
    }

    &__icon {
      flex-shrink: 0;
      font-size: 1.5rem;
      line-height: 1;
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    &__title {
      font-size: 0.85rem;
      color: #333;
      line-height: 1.4;
    }

    &__desc {
      font-size: 0.8rem;
      color: #e3165c;
      font-weight: bold;
      line-height: 1.4;
    }
  }

  .ai-reason-bnr-close-btn {
    position: absolute;
    display: inline-block;
    top: -10px;
    right: 0;
    width: 25px;
    height: 25px;
    background: #dfdfdf;
    border: none;
    border-radius: 50%;
    font-size: 19px;
    text-align: center;
    cursor: pointer;
    color: #e3165c;
  }
}
</style>

<script setup lang="ts">
import { computed, getCurrentInstance, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import { emitter } from '@/plugins/emitter'

type HostVm = {
  $globalVar: { isYagiPrime: boolean; in_app_payments: boolean }
  $eventHub: { $emit: (name: string) => void }
}

const route = useRoute()
const vm = getCurrentInstance()!.proxy as unknown as HostVm
const globalVar = vm.$globalVar
const showRandomly = ref(Math.random() < 0.7)

const bannerType = computed(() => {
  const currentPath = route.path
  if (/^\/format\/[^/]+\/edit\/reason$/.test(currentPath)) return 'reason'
  if (/^\/format\/[^/]+\/edit\/id-photo$/.test(currentPath)) return 'id-photo'
  return null
})

const title = computed(() =>
  bannerType.value === 'reason'
    ? '志望動機で手が止まっていませんか？'
    : '背景、そのままになっていませんか？'
)

const description = computed(() =>
  bannerType.value === 'reason'
    ? 'AIアシスタントが作成をサポートします'
    : '自撮り写真をアップロードするだけで背景を証明写真風に自動調整できます'
)

const shouldShowBanner = computed(() => {
  if (globalVar.isYagiPrime) return false
  if (!bannerType.value) return false
  return showRandomly.value
})

function closeBtn() {
  const element = document.querySelector('.ai-reason-bnr') as HTMLElement | null
  if (element) element.style.display = 'none'
}

function handleBannerClick() {
  if (bannerType.value === 'reason') {
    vm.$eventHub.$emit('open-ai-reason-dialog')
  } else if (bannerType.value === 'id-photo') {
    emitter.emit('open-idphoto-prime-dialog')
  }
}
</script>
